var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-header-container",class:[_vm.isHideBanner ? 'd-none' : 'd-block'],attrs:{"id":"banner-header-container"}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }